import { isOffsetBearingIso } from './validation.js';
const OFFSETLESS_ISO = /^\d{4}-\d{2}-\d{2}[Tt ]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/;
export function toInstantMs(value, legacyOffsetlessAsUtc = false) {
    if (value instanceof Date) {
        const ms = value.getTime();
        return Number.isNaN(ms) ? undefined : ms;
    }
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : undefined;
    }
    if (typeof value !== 'string')
        return undefined;
    if (!isOffsetBearingIso(value)) {
        if (!legacyOffsetlessAsUtc || !OFFSETLESS_ISO.test(value.trim()))
            return undefined;
        const legacyMs = new Date(`${value.trim()}Z`).getTime();
        return Number.isNaN(legacyMs) ? undefined : legacyMs;
    }
    const ms = new Date(value).getTime();
    return Number.isNaN(ms) ? undefined : ms;
}
//# sourceMappingURL=to-instant.js.map